<template>
    <div>
        <div class="site-form_group_label">{{ texts.sendingWhat }}</div>
        <pieces-list
          v-if="piecesFilter.length"
          :pieces="piecesFilter"
          @delete="onDeletePiece"
          @edit="onEditPiece"
        />
        <piece-edit v-if="editMode"
                    :editablePiece="editablePiece"
                    @save="onSavePiece"
                    @cancel="onCancelEdit"
        />
        <button v-if="!editMode && pieces.length >=  0"
                @click.prevent="onAddClick"
                class="button-light full"
        >
            + {{ texts.addPiece }}
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import piecesList from '@/components/pieces-list/pieces-list.component.vue';
import pieceEdit from './piece-edit/piece-edit.component.vue';
import PieceService from './piece.service';

export default {
  name: 'pieces',
  pieceService: new PieceService(),
  components: {
    pieceEdit,
    piecesList,
  },
  data() {
    return {
      editMode: false,
      editablePiece: null,
    };
  },
  mounted() {
    if (!this.editablePiece && this.pieces.length === 0) {
      this.onAddClick();
    }
  },
  computed: {
    ...mapGetters('preparation', ['locationTo']),
    ...mapGetters('preparation', ['pieces']),
    ...mapGetters('common', ['sessionSettings']),
    texts() {
      return {
        addPiece: this.$t('addPiece'),
        sendingWhat: this.$t('SendingWhat'),
      };
    },
    isContryNotDeliveryCargo() {
      const countryCode = this.$store.state.preparation.locationTo.CountryCode;
      if (countryCode) {
        return countryCode === 'KZ' || countryCode === 'AM' || countryCode === 'KG';
      }
      return false;
    },
    piecesFilter() {
      const piecesFiltered = [];

      for (const piece of this.pieces) {
        if (!(this.isContryNotDeliveryCargo && piece.type.alias !== 'Documents')) {
          piecesFiltered.push(piece);
        } else {
          this.onDeletePiece(piece);
        }
      }

      return piecesFiltered;
    },
  },
  methods: {
    ...mapActions('preparation', ['updatePiece', 'editPiece', 'removePiece', 'resetCalculation']),
    onEditPiece(piece) {
      this.editablePiece = piece;
      if (piece.id !== null && piece.id !== undefined) {
        this.editablePiece.id = piece.id;
      }
      this.editMode = true;
    },
    onAddClick() {
      this.editMode = true;
      this.editablePiece = this.$options.pieceService.getPiece();
    },
    onSavePiece(savedPiece) {
      this.editMode = false;
      this.updatePiece(savedPiece);
      this.editablePiece = null;
    },
    onDeletePiece(piece) {
      this.removePiece(piece);
      if (this.pieces.length === 0) {
        this.onAddClick();
      }
    },
    onCancelEdit() {
      this.editMode = false;
      this.editablePiece = null;
    },
  },
};
</script>

<style scoped>
  .button-light {
    margin-bottom: 32px;
  }
</style>
